import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { dutyColumns, dutyRows, fetchDutyRows } from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";

const DutyDataTable = () => {
  const [data, setData] = useState(dutyRows);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const rows = await fetchDutyRows();
      console.log("jawad", rows);
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();
  }, []);

  const handleDelete = (id) => {
    // Make a DELETE request to the Flask API endpoint
    fetch(`${serverUrl}/del_duty/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete duty");
        }
        setData((prevData) => prevData.filter((item) => item.id !== id));
        toast.success("Duty deleted successfully!");
      })
      .catch((error) => {
        console.error("Delete failed:", error);
        toast.error("Failed to delete duty. Please try again.");
      });
  };

  const viewLinkString = "Duty-Single";
  const editLinkString = "Duty-Edit";
  const newLinkString = "Duty-New";
  const newLinkString_1 = "Invigilationattendance-New";
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {params.row.job == "Invigilation" && (
              <>
                {/* Absent Form - only shown if status is Absent */}
                {slugs && slugs.includes(newLinkString_1) && (
                  <Link
                    to={`/Invigilation-attendance/new/${params.row.id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div className="viewButton">Attendance</div>
                  </Link>
                )}
              </>
            )}
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/duty/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/duty/update-duty/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3 pb-2 lg:pb-2">
        <div className="text-gray-700 text-2xl">Duties</div>
        <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
          {slugs && slugs.includes(newLinkString) && (
            <Link to="/duty/new" className="commonButton w-full sm:w-auto">
              Add New
            </Link>
          )}
        </div>
      </div>
      {loading ? (
        // <h1 style={{ textAlign: "center", paddingTop: "20%" }}>loading...</h1>
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={dutyColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar, // Include the GridToolbar in the Toolbar slot
          }}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default DutyDataTable;
